import { ModalActions, ModalBody, ModalHeroImage } from '@strava/ui/Modal';
import React, { useEffect } from 'react';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import headerImage from './images/all-set-header-image.jpg';

import styles from './AllSet.scss';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import { displayName } from '../../../../../../utils/general-utils';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';

const AllSet = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { firstName } = state.currentAthlete;

  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.all_set),
      action: 'screen_enter'
    });
  }, [track]);

  return (
    <>
      <ModalHeroImage src={headerImage} alt="" />
      <ModalBody>
        <h2 data-cy="all_set">
          {t('consents.all_set.title', { name: displayName({ firstName }) })}
        </h2>
        <p>{t('consents.all_set.p_1')}</p>
      </ModalBody>

      <ModalActions className={styles.modalActions}>
        <ActionButton
          variant="primary"
          onClick={() => stepForward(ACTIONS.done)}
          data-cy="all-set-next-step-btn"
          disabled={isProcessing}
        >
          {t('cta_actions.done')}
        </ActionButton>
      </ModalActions>
    </>
  );
};

export default AllSet;
